import { render, staticRenderFns } from "./lkuCpAgreement.vue?vue&type=template&id=80fe7612"
import script from "./lkuCpAgreement.vue?vue&type=script&lang=js"
export * from "./lkuCpAgreement.vue?vue&type=script&lang=js"
import style0 from "./lkuCpAgreement.vue?vue&type=style&index=0&id=80fe7612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports